import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assistance-dialog',
  templateUrl: './assistance-dialog.component.html',
  styleUrls: ['./assistance-dialog.component.scss']
})
export class AssistanceDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
